import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import SpeciesAssignModal from './components/SpeciesAssignModal';
import { hasIdentificationTag } from './utils/taxonGroups';
export default function addSpeciesControl() {
  // Mirrors vendor/flarum/tags' addTagControl.js - a button in the
  // discussion's controls dropdown. Shown only when the discussion has an
  // identification-relevant tag AND the actor is allowed to touch this
  // discussion's species (its author, a moderator, or an admin -
  // canAssignSpecies() is computed server-side, see extend.php).
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.session.user) return;
    if (!hasIdentificationTag(discussion.tags ? discussion.tags() : [])) return;
    if (!discussion.canAssignSpecies()) return;
    items.add('species', m(Button, {
      icon: "fas fa-dna",
      onclick: () => app.modal.show(SpeciesAssignModal, {
        discussion,
        // Model.save() takes a flat attributes map as its first arg,
        // not {attributes: {...}} - see vendor/flarum/core/js/src/common/Model.ts.
        onsubmit: entries => discussion.save({
          species: entries
        })
      })
    }, app.translator.trans('champis-species.forum.assign_species.control_button')));
  });
}